import thunk from 'redux-thunk';
import {
  applyMiddleware, compose, createStore, combineReducers
} from 'redux';
import { initializeBugsnag, bugsnagReduxMiddleware } from '@pagerduty/bugsnag-reporter';

import config from './config/app';
import feData from './features/fe-data/reducer';
import contentful from './features/contentful/reducer';
import navbarType from './features/navbar-type/reducer';

const allReducers = combineReducers({
  feData,
  contentful,
  navbarType
});

initializeBugsnag({
  apiKey: config.BUGSNAG_API_KEY
});

let allStoreEnhancers = compose(
  applyMiddleware(
    thunk,
    bugsnagReduxMiddleware({ actionErrorSuffix: '_FAILURE' }),
  )
);

// split this to avoid an error when devToolsExtension is null
if (window.devToolsExtension) {
  allStoreEnhancers = compose(allStoreEnhancers, window.devToolsExtension());
}

const store = createStore(allReducers, undefined, allStoreEnhancers);

export default store;
